import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '@chakra-ui/react';

import flyingBills from 'assets/brand/flying-bills@2x.png';
import Button from 'components/_core/Button';
import { StepProps } from 'components/Stepper/types';
import * as ContentLayout from 'layouts/ContentLayout';

import { useMandateCreationFlowContext } from '../../hooks/useMandateCreationFlowContext';
import locales from './locales';
import * as S from './styles';

const StepMandateCreationSuccess: FC<StepProps> = () => {
  const { sharedState } = useMandateCreationFlowContext();
  const { createdMandateId } = sharedState;

  return (
    <ContentLayout.Root>
      <ContentLayout.Body>
        <S.Container>
          <Image boxSize={180} marginBottom="space-24" src={flyingBills} />
          <S.Title>{locales.title}</S.Title>
          <S.InfoText>{locales.infoText}</S.InfoText>

          <S.NextButtonContainer>
            <Button
              as={Link}
              to={`/payments/mandates/${createdMandateId}`}
              width="100%"
            >
              {locales.ctaButton}
            </Button>
          </S.NextButtonContainer>
        </S.Container>
      </ContentLayout.Body>
    </ContentLayout.Root>
  );
};

export default StepMandateCreationSuccess;
